import { render } from "./ListeTag.vue?vue&type=template&id=66bdac4e&ts=true"
import script from "./ListeTag.vue?vue&type=script&lang=ts"
export * from "./ListeTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__